<template>
  <div class="maincontainer">
    <h1 class="title">退換貨須知</h1>

    <!-- 資料尚未載入，顯示佔位 -->
    <div v-if="!loaded" class="placeholder">
      <p>載入中...</p>
    </div>

    <!-- 資料載入後：用 v-html 插入原始 HTML，不改動結構 -->
    <div
      v-else
      class="html-container"
      ref="htmlContainer"
      v-html="txthtml"
    ></div>
  </div>
</template>


<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { usePageStore } from '@/store/pageStore.js'

const txthtml = ref('')
const loaded = ref(false)
const htmlContainer = ref(null) // 取得 v-html 插入的外層容器

onMounted(async () => {
  // 1. 從後端拿 HTML
  const pageStore = usePageStore()
  await pageStore.fetchProductreturnsData()

  txthtml.value = pageStore.ProductreturnsHtml || ''

  // 2. 遞延一點時間 or 直接 loaded = true
  loaded.value = true

  // 3. 等 DOM 更新
  await nextTick()

  // 4. 讓每一行 / 段落 先「opacity=0, transformY(20px)」
  //   (此時 DOM 已插入 .html-container)
  initFadeLines()
  // 5. 再用 setTimeout 逐行淡入
  fadeInLines()
})

function initFadeLines() {
  // 從 .html-container 中挑出您想處理的標籤
  // 例如 p, li, h2, 或您自定
  const lines = htmlContainer.value?.querySelectorAll('span , p, li, h2, blockquote')
  if (!lines) return

  lines.forEach(el => {
    // 設定初始樣式
    el.style.opacity = '0'
    el.style.transform = 'translateY(20px)'
    el.style.transition = 'all 0.4s ease'
  })
}

// 逐行顯示
function fadeInLines() {
  const lines = htmlContainer.value?.querySelectorAll('span , p, li, h2, blockquote')
  if (!lines) return

  lines.forEach((el, index) => {
    // 每行延遲 index * 200ms
    setTimeout(() => {
      el.style.opacity = '1'
      el.style.transform = 'translateY(0)'
    }, index * 200)
  })
}
</script>


<style scoped>
.maincontainer {
  max-width: 800px;
  margin: auto;
  padding: 20px;
}
.title {
  text-align: center;
  margin-bottom: 1rem;
}
.placeholder {
  min-height: 200px; /* 先留空間 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
}
/* 預留外層 (可根據需求) */
.html-container {
  /* 讓長文字自動換行 */
  overflow-wrap: break-word;
  word-wrap: break-word;
}
/* 不需要 transition-group => 自行 JS set style */
</style>
